import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { SnakStill } from '../SnakStill';
import { journeyStages } from '../../data/snakkerStory';
export function SlideJourney({}: SlideProps) {
  return <InteriorSlide data-id="element-436" data-mp="206o46xtzhfb9">
      <SlideTitle eyebrow="The journey" data-id="element-437" data-mp="207fqtj5ls2pe">
        Promise <span className="font-light text-[var(--brand-light)]" data-id="element-438" data-mp="2wwezv0e0h8in">→</span> Effort{' '}
        <span className="font-light text-[var(--brand-light)]" data-id="element-439" data-mp="2wuawqknxsdjf">→</span> Reward{' '}
        <span className="font-light text-[var(--brand-light)]" data-id="element-440" data-mp="2svlcq98e7xqt">→</span> <span className="text-[var(--brand)]" data-id="element-441" data-mp="2nuxm3oo2tix4">Next step</span>
      </SlideTitle>

      <div className="mt-[clamp(1.25rem,2.5vw,2.25rem)] grid min-h-0 flex-1 grid-cols-4 gap-[clamp(1rem,2vw,2rem)]" data-id="element-442" data-mp="2iww313qnhjln">
        {journeyStages.map((stage, i) => <motion.section key={stage.title} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15 + i * 0.1,
        duration: 0.45
      }} className="flex min-h-0 min-w-0 flex-col" data-id="element-443" data-mp="1ceh3jmh86m61" data-mpi={i}>
            <div className="flex items-baseline gap-2 border-t border-[var(--fg)] pt-[clamp(0.6rem,1.1vw,0.9rem)]" data-id="element-444" data-mp="305ioptug7600">
              <span className="font-mono text-[clamp(0.6rem,0.78vw,0.72rem)] tracking-[0.2em] text-[var(--muted)]" data-id="element-445" data-mp="2m6sx2tqedyj1">0{i + 1}</span>
              <h3 className="text-[clamp(1.3rem,2.2vw,2.1rem)] font-extrabold tracking-[-0.04em] text-[var(--fg)]" data-id="element-446" data-mp="2ch9c9ij4julj">{stage.title}</h3>
            </div>
            <p className="mt-[clamp(0.35rem,0.7vw,0.6rem)] min-h-[2.6em] text-[clamp(0.82rem,1.1vw,1.04rem)] font-medium leading-snug text-[var(--muted)]" data-id="element-447" data-mp="2h8r9bvi11b18">
              {stage.ask}
            </p>

            <div className="mt-[clamp(0.7rem,1.4vw,1.2rem)] flex min-h-0 flex-1 flex-col rounded-2xl bg-[var(--surface)] p-[clamp(0.6rem,1.1vw,1rem)]" data-id="element-448" data-mp="28gfk2cynftmu">
              <SnakStill screen={stage.screen} alt={`${stage.title}: ${stage.example}`} className="w-full flex-1" data-id="element-449" data-mp="1yh6xi5645hai" />
              <p className="mt-[clamp(0.5rem,0.9vw,0.75rem)] text-center text-[clamp(0.72rem,0.95vw,0.9rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-450" data-mp="1fdd344pnklf4">
                {stage.example}
              </p>
            </div>
          </motion.section>)}
      </div>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6,
      duration: 0.5
    }} className="mt-[clamp(0.6rem,1.1vw,0.9rem)] flex-shrink-0 font-mono text-[clamp(0.56rem,0.72vw,0.68rem)] uppercase tracking-[0.18em] text-[var(--muted)]" data-id="element-451" data-mp="10nyw339jug2w">
        Worked example · the REKOVELLE teaser Snak
      </motion.p>
    </InteriorSlide>;
}